import {
  browserTracingIntegration,
  init as initSentryReact,
  reactRouterV7BrowserTracingIntegration,
} from '@sentry/react';
import * as SentryElectron from '@sentry/electron/renderer';

import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { SENTRY_RELEASE } from 'utils/sentryRelease';

export function initSentry() {
  if (import.meta.env.MODE === 'dev') {
    return;
  }

  if (typeof window !== 'undefined' && window.electronAPI?.isE2ETest) {
    return;
  }

  if (!import.meta.env.VITE_SENTRY_DSN) {
    return;
  }

  SentryElectron.init(
    {
      dsn: import.meta.env.VITE_SENTRY_DSN as string,
      environment: import.meta.env.MODE,
      attachStacktrace: true,
      integrations: [
        reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        browserTracingIntegration(),
      ],
      // Performance Monitoring
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
      release: SENTRY_RELEASE,
      beforeSend(event) {
        // Filter out dev errors in production
        if (import.meta.env.PROD && event.exception) {
          const error = event.exception.values?.[0];
          if (error?.value?.includes('Non-Error promise rejection captured')) {
            return null;
          }
          // Filter out common non-actionable errors
          if (error?.value?.includes('Network Error') && error?.value?.includes('fetch')) {
            return null;
          }
        }
        return event;
      },
    },
    initSentryReact
  );
}
